
<section class="global-background-div">
    <div class="global-markdown-container">
        <markdown [src]="markdownUrl" class="custom-markdown"></markdown>
    </div>
</section>

